import _ from 'lodash'

/**
 *
 * json 对象序列化
 * 举例：{ a: 1, b: undefined, c: null, d: 4 } ==> a=1&d=4
 *
 * @param {Object} paramsObj 要序列化的 json 对象
 * @param {Object} options 
 * @param {String} options.skipNull 默认 true，跳过空值(null、undefined)
 * @param {String} options.skipEmptyString 默认 false，跳过空字符串('')
 *
 * @returns {String} 已序列化的字符串
 */
function stringify(paramsObj, options = {}) {
  const { skipNull, skipEmptyString } = _.extend({ skipNull: true, skipEmptyString: false }, options)
  let paramsStr = ''

  if (!_.isObject(paramsObj)) {
    return paramsStr
  }

  _.each(paramsObj, (value, key) => {
    // 跳过空值
    if (skipNull && (_.isNull(value) || _.isUndefined(value))) return
    // 跳过空字符串
    if (skipEmptyString && value === '') return
    
    paramsStr += `${key}=${encodeURIComponent(value)}&`
  })

  return paramsStr.slice(0, -1)
}

/**
 *
 * 解析字符串(一般为location[href|search|hash])中序列化的参数
 *
 * @param {String} input 要解析的字符串
 * @param {Object} options
 * @param {String} options.priority 同名参数优先级, 可取值有: front | back, 默认为back, 靠后的覆盖靠前的
 * @param {String} options.skipEmptyString 默认 true，跳过空字符串('')
 * 
 * @returns {Object} kvMap 最终解析的key-value对象
 */
function parse(input = '', options = {}) {
  const { priority, skipEmptyString } = _.extend({ priority: 'back', skipEmptyString: true }, options)

  if (_.isEmpty(input) || !_.includes(input, '?')) {
    return {}
  }

  input = input.substr(input.indexOf('?') + 1)
  // '#/path?' 或者 '#/path' 替换为 '&'
  // 例如:
  // 'a=123#/path' -> 'a=123&'
  // 'a=123#/path?b=456' -> 'a=123&b=456'
  input = _.replace(input, /#\/(.*\?|.*)/g, '&')
  
  const kvMap = {}
  const kvArr = _.split(input, '&')
  
  // 是否需要调整为靠前的优先级高
  if (priority === 'front') {
    _.reverse(kvArr)
  }

  _.each(kvArr, kv => {
    // 过滤无效字段：''、'xxx'等
    if (_.includes(kv, '=')) {
      // 注意：k中不会有'=', 但v中可能存在'=', 所以不能用split，要根据第一个'='位置来截取字符串
      const splitIndex = kv.indexOf('=')
      const k = kv.slice(0, splitIndex)
      const v = kv.slice(splitIndex + 1)
      // 是否跳过空字符串，默认是true
      // 原因：方便使用ES6解构的时候，使用默认值
      if (skipEmptyString && v === '') return

      kvMap[k] = decodeURIComponent(v)
    }
  })

  return kvMap
}

/**
 * 将url中动态key替换为具体value
 * key1=${key1}&key2=${key2} => key1=value1&key2=value2
 * @param {String} link
 * @param {Object} data 形如 {key1: value1, key2: value2}
 * @returns {String} 已替换实际参数的url
 * 在使用openwebview打开某个url的时候，url中带有中文字符ios是跳不过去的，需要进行编码处理
 */
function replace(link, data) {
  return link.replace(/\$\{(\w+)\}/g, (match, key) => {
    return encodeURIComponent(data[key]) || ''
  })
}

export default {
  stringify,
  parse,
  replace,
}
